
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Championship </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="title-heading inner-heading text-center mb-5 shadow-text-sm">
            <h2>Nagpur District Under-7 Open and <span >Girls Chess Championship
                </span>
            </h2>
            <h6>Nagpur District Under-7 Open and Girls Chess Championship
                organized by Chess
                Association Nagpur in association with G.H.Raisoni Sports and Cultural
                Foundation and Kalpana Prakash Welfare Foundation</h6>
        </div>
        <div class="row">
            <div class="col-md-12 up-event-text">

                <h6 class="fw-bold">Date of competition 31<sup>th</sup> March 2024 </h6>
                <p class="text-justify">Ayush Ramteke in Open Group and Rashmika Maringanti in Girls Group Annexed the
                    Title of
                    the  Nagpur District Under-17 Open and Girls Chess Championship whereas Nihansh Khode in
                    Open Group and Gargi Harkare in Girls Group emerged triumphant in Nagpur District Under-7
                    Open and Girls Chess Championship organized by Chess Association Nagpur in association
                    with  G.H.Raisoni  Sports and Cultural Foundation and Kalpana Prakash Welfare Foundation at
                    Vivekanand Hall, Shraddha House, Kingsway, Near Kasturchand Park, Nagpur on 31 st  March
                    2024. The Championship was conducted for selection of Nagpur District Chess players for
                    participation in the Maharashtra State Under-17 and Under-7 Open and Girls Chess
                    Championship 2024 to be held later this year.</p>
                <p>
                    In the Under-17 open group, Ayush Ramteke scored 4.5 rounds out of five to clinch the Top spot.
                    Sharma Sai also scored 4.5 points however he was placed second based on the tie break score.
                    Sahajveer Singh Maras, Avadhoot Deshmukh and Prerak Darvekar all scored 4 points and were
                    adjudged Third to Fifth in the merit list based on their tie break score.
                </p>
                <p> In the Girls Under-17 Group, Rashmika Maringanti was way ahead of the rest by scoring 5 point
                    out of Five to take the top spot. Anvi Hirde and Aparnita Jagtap scored 4 points to tie for second
                    spot but were placed second and third based on their tie break score.
                </p>
                <p> In the Under-7 open group, Nihansh Khode with 4.5 points out of Five emerged a clear winner.
                    Dev Gandhi with 4 points stood second. Dhawal Deshmukh scored 3.5 points out of Five took
                    the third spot.
                </p>
                <p> In the Girls Under -7 Group, there was a Threeway tie for the First place between Gargi Harkare,
                    NIharika Nilesh Rathi and Geet Gwalani. Based on the tie break score, Gargi was declared
                    winner while Niharika and Geet were placed 2 nd  and 3 rd  respectively in the merit list.
                    Ayush Ramteke and Sharma Sai in Open Under-17 open Group and Rashmika Maringanti and
                    Anvi Hirde in Girls Under-17 Group shall represent Nagpur District in the Maharashtra Under-
                    17 Chess Championship to be held later this year. In the Under-7 category, Nihansh Khode and
                    Dev Gandhi in Open Group and Gargi Harkare and Niharika Nilesh Rathi in Girls group shall
                    represent Nagpur District in upcoming Maharashtra State Under-7 Chess Championship.
                </p>
                <p> Prizes were distributed at the hands of Shri.  S.S.Soman , Member of MCA Observer Committee.
                    Shri Bhushan Shriwas, Secretary of Chess Association Nagpur &amp; Kalpana Prakash Welfare
                    Foundation and Chief Arbiter FA Shiva Iyer were present on the dias. Shri Shyam Agrawal
                    conducted the programme, announced the name of winners and proposed vote of thanks.
                    The Trophies and Medals were given to the Top 10 winners in each group. In addition, the age
                    group prizes were distributed to Best Under-7, 9, 11, 13 and 15 age group performers.
                </p>
                <p> FA Shiva Iyer, Chief Arbiter successfully conducted the event who was assisted by SNA Prayas
                    Ambade, SNA Shyam Agrawal and Prathamesh Machave.
            </div>

        </div>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess-2.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess-2.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess-1.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess-1.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
